module.exports = __webpack_public_path__ + "img/waf-icon-active copy.09d944b.svg";